module.exports = __webpack_public_path__ + "img/jpm_clock-icon.a614e2e9.png";